import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import {
  SchoolBreakDetailsView,
  schoolBreakQueryOptions
} from '@/modules/schoolSettings'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute('/_auth/school-settings/breaks/$breakId/')(
  {
    component: SchoolBreakDetailsView,
    loader: async ({ context, params }) => {
      const { name } = await context.queryClient.ensureQueryData(
        schoolBreakQueryOptions(params.breakId)
      )
      return name
    },
    head: ({ loaderData }) =>
      getMetaWithPageTitle([
        loaderData,
        i18n.t('title.details', { ns: 'schoolSettings' })
      ])
  }
)
